module.exports = __webpack_public_path__ + "img/product-digital-signage-software.b76a00b1.jpg";